// @flow
import Resource from 'app/common/lib/ResourceFactory';
import type { BlockingActionResourceData } from 'app/packages/pinterest-flow-types/board';
import type { Thunk } from 'app/common/redux/types';

type BlockingActionsUpdatedPayload = {
  boardId: string,
  blockingActions: Array<BlockingActionResourceData>,
};

export type BlockingActionsUpdated = {
  type: 'BLOCKING_ACTIONS_UPDATED',
  payload: BlockingActionsUpdatedPayload,
};

export function blockingActionsUpdated(
  payload: BlockingActionsUpdatedPayload,
): BlockingActionsUpdated {
  return { type: 'BLOCKING_ACTIONS_UPDATED', payload };
}

function fetchBlockingActionsFromResource(
  boardId: string,
): Promise<Array<BlockingActionResourceData>> {
  return Resource.create('BoardActionStatusResource', { board_id: boardId })
    .callGet({ showError: false })
    .then(
      (response: any) =>
        new Promise((resolve, reject) => {
          const blockingActions =
            response &&
            response.resource_response &&
            response.resource_response.data &&
            response.resource_response.data.blocking_actions;
          if (!blockingActions) {
            reject(new Error('No blocking actions found in the response'));
            return;
          }
          resolve(blockingActions);
        }),
    );
}

export function fetchBlockingActions(
  boardId: string,
): Thunk<Promise<Array<BlockingActionResourceData>>> {
  return (dispatch) =>
    fetchBlockingActionsFromResource(boardId).then((blockingActions) => {
      dispatch(blockingActionsUpdated({ boardId, blockingActions }));
      return blockingActions;
    });
}
